import React, { createContext, useContext, useState } from 'react';
import axiosInstance from '../../../../../../api/axiosInstance';

interface IState {
  state: {
    url: string;
    isLoading: boolean;
    listData: [];
    page: number;
    perPage: number;
    search: string;
    jumlahData: number;
    status: string;
  };
  dispatch: {
    setPengetahuanPendaftar: Function;
    fetchData: Function;
  };
}

const initialState: IState = {
  state: {
    url: 'pengetahuan/',
    isLoading: false,
    listData: [],
    page: 1,
    perPage: 10,
    search: '',
    jumlahData: 0,
    status: '',
  },
  dispatch: {
    setPengetahuanPendaftar: () => {},
    fetchData: () => {},
  },
};

const Context = createContext<IState>(initialState);
const { Provider: ManajemenPengetahuanPendaftarProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = useState<IState>(initialState);
  const { url, page, perPage, search, status } = state.state;

  const setPengetahuanPendaftar = (key: keyof IState['state'], value: any) => {
    setState((prevState) => ({
      ...prevState,
      state: {
        ...prevState.state,
        [key]: value,
      },
    }));
  };

  const fetchData = async (id: number) => {
    setPengetahuanPendaftar('isLoading', true);

    try {
      const response = await axiosInstance.get(url + id + '/approvals', {
        params: {
          page,
          per_page: perPage,
          search: search,
          status: status,
        },
      });

      setPengetahuanPendaftar('listData', response.data.data);
      setPengetahuanPendaftar('jumlahData', response.data.total);
    } catch (error) {
      const status = error?.response?.status;
      if (status === 400) {
        setPengetahuanPendaftar('listData', []);
        setPengetahuanPendaftar('jumlahData', 0);
      }
    } finally {
      setPengetahuanPendaftar('isLoading', false);
    }
  };

  return (
    <ManajemenPengetahuanPendaftarProvider
      value={{
        state: state.state,
        dispatch: {
          setPengetahuanPendaftar,
          fetchData,
        },
      }}
    >
      {children}
    </ManajemenPengetahuanPendaftarProvider>
  );
};

export const useManajemenPengetahuanPendaftarContext = () =>
  useContext(Context);

const ManajemenPengetahuanPendaftarController = {
  useManajemenPengetahuanPendaftarContext,
  Provider,
};

export default ManajemenPengetahuanPendaftarController;
